module.exports = __webpack_public_path__ + "img/c4-m.96f211d9.jpg";